import { Observable } from "rxjs";
import HttpClient from "@/api/HttpClient";
import { APIHosts, ApiReduxHelpers } from "@/services/reduxHelpers";
import type { ArchiveFileRequest } from "./archiveFileSlice";

export type ArchiveFileResponse = {
  success: boolean;
  archiveKey?: string;
  message?: string;
};

class ArchiveFileService extends ApiReduxHelpers {
  constructor() {
    super();
  }

  ApiHost = APIHosts.App;

  private envHeaders() {
    const env =
      (import.meta as any).env?.VITE_INERTIA_ENV ||
      localStorage.getItem("inertiaEnv") ||
      "NonProd";
    const profile =
      (import.meta as any).env?.VITE_INERTIA_PROFILE ||
      localStorage.getItem("inertiaProfile") ||
      "315";
    return {
      "X-Inertia-Env": env,
      ...(profile ? { "X-Inertia-Profile": profile } : {}),
    };
  }

  archiveFile(request: ArchiveFileRequest): Observable<ArchiveFileResponse> {
    return HttpClient.post<ArchiveFileResponse>(
      `${this.getHost(this.ApiHost)}/api/archive/archive-file`,
      request,
      {
        headers: this.envHeaders(),
      }
    );
  }
}

const archiveFileService = new ArchiveFileService();
export default archiveFileService;